export default "__VITE_ASSET__mJeBFEEY__"